import { observer } from "mobx-react";
import { Fragment, h } from "preact";
import { t, translate } from "restaumatic-client";
import CartBody from "./CartBody";
import CartFooter from "./CartFooter";
import CartHeader from "./CartHeader";
import CartImage from "./CartImage";
function Cart(props) {
    const { state, imageUrn } = props;
    const { isRedirecting } = state;
    const hasImage = imageUrn !== null;
    const isSubmitDisabled = !state.cart.isReadyForCheckout;
    const isContinueVisible = state.cart.isEmpty ||
        !Skubacz.Device.screen.isMobileSize() ||
        Skubacz.configuration.theme_name === "active_menu";
    const handleClear = () => {
        const message = translate(t.restaurants.widgets.cart.clear_confirmation);
        if (window.confirm(message)) {
            state.cart.clear();
        }
    };
    return (h(Fragment, null,
        hasImage && h(CartImage, { imageUrn: imageUrn }),
        h(CartHeader, { isClearVisible: !state.cart.isEmpty, onClear: handleClear }),
        h("div", { class: "modal-body js-popover-container" },
            h(CartBody, { openProductCard: (productCardCreatorInput) => state.openProductCard(productCardCreatorInput), cart: state.cart })),
        h(CartFooter, { price: state.cart.price, isSubmitDisabled: isSubmitDisabled, isSubmitLoading: isRedirecting, isContinueVisible: isContinueVisible, shortForOrderAlert: state.cart.shortForOrderAlert, onContinue: () => state.hideModal(), onSubmit: () => state.goToCheckout(isSubmitDisabled) })));
}
export default observer(Cart);
